import { Gtm } from '../../../requests/caipirinha-api/interfaces/gtm.interface';
import { Order } from '../../../requests/caipirinha-api/interfaces/order.interface';
import { useGtm } from '../useGtm';
import { IPageInfo } from '../useGtm.interface';

export const useDefaultGtm = () => {
  const {
    getCityState,
    getCookieValue,
    getDevice,
    getHitTimestamp,
    setDataLayer,
  } = useGtm();

  const sendDataToGtm = (
    info: IPageInfo,
    order?: Order,
    logged = true,
  ): void => {
    const gtmData: Gtm = {
      event: 'virtualPageview',
      pageType: info.type || 'checkout',
      pageName: info.name,
      clientId: getCookieValue(),
      device: getDevice(),
      loginAtivo: logged ? 'logado' : 'deslogado',
      hitTimestamp: getHitTimestamp(),
    };

    if (order) {
      const { details } = order;

      let cidadeuf: string | undefined;
      if (details.delivery.address) {
        const { city, state } = details.delivery.address;
        cidadeuf = getCityState(city, state);
      }

      setDataLayer({
        ...gtmData,
        idUsuario: details.customer.documentNumber,
        cidadeuf,
      });

      return;
    }

    setDataLayer({
      ...gtmData,
    });
  };

  return { sendDataToGtm };
};
